module.exports = __webpack_public_path__ + "static/media/Evira final Cam 2.ff05c52c.webp";